import { Box, Grid, Skeleton } from "@mui/material";
import DashboardListsPageSkeleton from "Components/Dashboard/DashboardListsSkeleton";
import FullScreenSpinner from "Components/FullScreenSpinner/FullScreenSpinner";
import EditUserDetailsSkeleton from "Components/EditUserDetails/EditUserDetailsSkeleton";
import MyNetworkRouteSkeleton from "Pages/MyNetwork/components/MyNetworkRouteSkeleton";
import SubscriptionPageSkeleton from "Pages/Subscriptions/SubscriptionPageSkeleton";
import { useLocation } from "react-router-dom";

const PlaygroundRouteSkeleton = () => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        pb: "64px",
        background:
          "radial-gradient(760px 280px at 8% -10%, rgba(1, 170, 245, 0.14), transparent 72%), radial-gradient(680px 260px at 96% 2%, rgba(145, 201, 74, 0.12), transparent 74%), linear-gradient(180deg, #eef2f7 0%, #f4f7fb 100%)",
      }}
    >
      <Box
        sx={{
          width: "min(1660px, 100%)",
          mx: "auto",
          px: "clamp(14px, 3.6vw, 48px)",
          pt: "26px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
            gap: 2,
            flexWrap: "wrap",
            mb: 2.25,
          }}
        >
          <Box>
            <Skeleton variant="text" width={154} height={24} />
            <Skeleton variant="text" width={420} height={54} />
          </Box>
          <Skeleton variant="text" width={360} height={28} />
        </Box>

        <Grid container spacing={2.25} sx={{ mb: 4 }}>
          {Array.from({ length: 3 }).map((_, idx) => (
            <Grid item xs={12} lg={4} key={`route-playground-card-skeleton-${idx}`}>
              <Box
                sx={{
                  borderRadius: "26px",
                  overflow: "hidden",
                  border: "1px solid rgba(15, 23, 42, 0.08)",
                  background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
                  boxShadow: "0 18px 32px rgba(15, 23, 42, 0.1)",
                }}
              >
                <Box
                  sx={{
                    p: 2.75,
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(247,251,255,0.96) 100%)",
                  }}
                >
                  <Skeleton variant="rounded" width={52} height={52} sx={{ borderRadius: "16px" }} />
                  <Skeleton variant="text" width="34%" height={24} sx={{ mt: 1.5 }} />
                  <Skeleton variant="text" width="62%" height={40} />
                  <Skeleton variant="text" width="88%" height={28} />
                <Box sx={{ display: "flex", gap: 1, mt: 2, flexWrap: "wrap" }}>
                  <Skeleton variant="rounded" width={78} height={30} sx={{ borderRadius: "999px" }} />
                  <Skeleton variant="rounded" width={92} height={30} sx={{ borderRadius: "999px" }} />
                  <Skeleton variant="rounded" width={86} height={30} sx={{ borderRadius: "999px" }} />
                </Box>
              </Box>
                <Box
                  sx={{
                    p: "0 22px 22px",
                    minHeight: 248,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ my: "auto", py: 2.25 }}>
                    <Skeleton variant="text" width="100%" height={24} />
                    <Skeleton variant="text" width="94%" height={24} />
                    <Skeleton variant="text" width="78%" height={24} />
                  </Box>
                  <Skeleton variant="text" width="68%" height={24} sx={{ mt: 0.5, mb: 1 }} />
                  <Box sx={{ display: "flex", gap: 1.25, flexWrap: "wrap", mt: 1 }}>
                    <Skeleton variant="rounded" width={156} height={44} sx={{ borderRadius: "13px" }} />
                    <Skeleton variant="rounded" width={146} height={44} sx={{ borderRadius: "13px" }} />
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            borderRadius: "26px",
            p: { xs: 2, md: 3 },
            border: "1px solid rgba(15, 23, 42, 0.08)",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(248,251,255,0.93) 100%)",
            boxShadow: "0 18px 34px rgba(15, 23, 42, 0.1)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 2,
              flexWrap: "wrap",
              mb: 2.25,
            }}
          >
            <Box>
              <Skeleton variant="text" width={240} height={48} />
              <Skeleton variant="text" width={330} height={26} />
              <Box sx={{ display: "flex", gap: 1.25, flexWrap: "wrap", mt: 1.5 }}>
                <Skeleton variant="rounded" width={122} height={64} sx={{ borderRadius: "16px" }} />
                <Skeleton variant="rounded" width={122} height={64} sx={{ borderRadius: "16px" }} />
                <Skeleton variant="rounded" width={122} height={64} sx={{ borderRadius: "16px" }} />
              </Box>
            </Box>

            <Box
              sx={{
                minWidth: { xs: "100%", md: 350 },
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(150px, 1fr))" },
                gap: 1.25,
                p: 1.5,
                borderRadius: "18px",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                background: "rgba(255,255,255,0.9)",
                boxShadow: "0 12px 20px rgba(15, 23, 42, 0.06)",
              }}
            >
              <Box>
                <Skeleton variant="text" width={56} height={22} />
                <Skeleton variant="rounded" width="100%" height={42} sx={{ borderRadius: "12px" }} />
              </Box>
              <Box>
                <Skeleton variant="text" width={94} height={22} />
                <Skeleton variant="rounded" width="100%" height={42} sx={{ borderRadius: "12px" }} />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              borderRadius: "22px",
              overflow: "hidden",
              border: "1px solid rgba(15, 23, 42, 0.08)",
              boxShadow: "0 14px 28px rgba(15, 23, 42, 0.09)",
              background: "#fff",
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "110px 1.25fr 1fr 150px 180px",
                gap: 2,
                px: 2,
                py: 1.6,
                borderBottom: "1px solid #dce4ef",
                "@media (max-width: 900px)": {
                  display: "none",
                },
              }}
            >
              {Array.from({ length: 5 }).map((_, idx) => (
                <Skeleton key={`route-playground-head-skeleton-${idx}`} variant="text" width="72%" height={24} />
              ))}
            </Box>

            <Box sx={{ p: { xs: 1.5, md: 0 } }}>
              {Array.from({ length: 5 }).map((_, idx) => (
                <Box
                  key={`route-playground-row-skeleton-${idx}`}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "110px 1.25fr 1fr 150px 180px" },
                    gap: 2,
                    alignItems: "center",
                    px: { xs: 0, md: 2 },
                    py: 1.75,
                    borderBottom: idx === 4 ? 0 : "1px solid #e8edf5",
                  }}
                >
                  <Skeleton variant="text" width={48} height={30} />
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                    <Skeleton variant="circular" width={36} height={36} />
                    <Skeleton variant="text" width={180} height={28} />
                  </Box>
                  <Skeleton variant="text" width={220} height={28} />
                  <Skeleton variant="text" width={84} height={28} />
                  <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
                    <Skeleton variant="circular" width={26} height={26} />
                    <Skeleton variant="circular" width={26} height={26} />
                    <Skeleton variant="circular" width={26} height={26} />
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const GamesRouteSkeleton = () => {
  const renderGameCardSkeleton = (key, featured = false) => (
    <Box
      key={key}
      sx={{
        borderRadius: "20px",
        border: "1px solid #f1f1f1",
        backgroundColor: "#ffffff",
        boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",
        overflow: "hidden",
        p: "12px",
      }}
    >
      <Skeleton
        variant="rounded"
        height={featured ? 300 : 220}
        sx={{ borderRadius: "14px", mb: 1.5, bgcolor: "#f1f1f4" }}
      />
      <Skeleton variant="text" width="34%" height={18} />
      <Skeleton variant="text" width="46%" height={30} sx={{ mb: 0.5 }} />
      <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: featured ? 0 : 4 }}>
        <Skeleton variant="rounded" width={112} height={26} sx={{ borderRadius: "999px" }} />
        <Skeleton variant="rounded" width={92} height={26} sx={{ borderRadius: "999px" }} />
      </Box>
      {!featured ? (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Skeleton variant="circular" width={32} height={32} />
        </Box>
      ) : null}
    </Box>
  );

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", backgroundColor: "#fafafa", pb: "56px" }}>
      <Box
        sx={{
          width: "min(1660px, 100%)",
          mx: "auto",
          px: "clamp(16px, 4vw, 48px)",
          pt: "52px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            mt: "8px",
            mb: "18px",
          }}
        >
          <Skeleton variant="circular" width={36} height={36} sx={{ bgcolor: "#dff3ff" }} />
          <Skeleton
            variant="text"
            width="min(420px, 72vw)"
            height={54}
            sx={{ transform: "none" }}
          />
        </Box>

        <Grid container spacing={3} sx={{ mb: "22px" }}>
          {Array.from({ length: 3 }).map((_, idx) => (
            <Grid item xs={12} md={4} key={`route-games-featured-skeleton-${idx}`}>
              {renderGameCardSkeleton(`route-games-featured-card-${idx}`, true)}
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            flexWrap: "wrap",
            mb: "44px",
          }}
        >
          <Skeleton
            variant="rounded"
            width={314}
            height={56}
            sx={{ borderRadius: "999px", maxWidth: "100%" }}
          />
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", justifyContent: "flex-end" }}>
            <Skeleton variant="rounded" width={156} height={48} sx={{ borderRadius: "999px" }} />
            <Skeleton variant="rounded" width={190} height={48} sx={{ borderRadius: "999px" }} />
          </Box>
        </Box>

        <Grid container spacing={3}>
          {Array.from({ length: 6 }).map((_, idx) => (
            <Grid item xs={12} sm={6} md={4} key={`route-games-grid-skeleton-${idx}`}>
              {renderGameCardSkeleton(`route-games-grid-card-${idx}`)}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

const GamesResultsRouteSkeleton = () => {
  return (
    <Box sx={{ width: "100%", minHeight: "100vh", backgroundColor: "#fafafa", pb: "56px" }}>
      <Box
        sx={{
          width: "min(1660px, 100%)",
          mx: "auto",
          px: "clamp(16px, 4vw, 48px)",
          pt: "52px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1.2 }}>
          <Skeleton variant="circular" width={34} height={34} />
          <Skeleton variant="text" width={130} height={34} />
        </Box>

        <Skeleton variant="text" width={410} height={58} />
        <Skeleton variant="rounded" width={236} height={40} sx={{ borderRadius: "999px", mb: 2 }} />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", lg: "minmax(0, 1fr) 300px" },
            gap: 2.5,
            alignItems: "start",
          }}
        >
          <Box sx={{ borderRadius: "18px", border: "1px solid rgba(15, 23, 42, 0.08)", background: "#fff", p: 2 }}>
            <Skeleton variant="rounded" height={50} sx={{ borderRadius: "12px", mb: 1.25 }} />
            {Array.from({ length: 6 }).map((_, idx) => (
              <Box
                key={`route-games-results-row-skeleton-${idx}`}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "70px minmax(130px, 1.1fr) minmax(120px, 1fr) minmax(120px, 1fr) 90px 90px 110px",
                  alignItems: "center",
                  gap: 1,
                  py: 1.2,
                  borderBottom:
                    idx === 5 ? "none" : "1px solid rgba(15, 23, 42, 0.06)",
                }}
              >
                <Skeleton variant="text" width={40} height={26} />
                <Skeleton variant="text" width="88%" height={26} />
                <Skeleton variant="text" width="84%" height={26} />
                <Skeleton variant="text" width="86%" height={26} />
                <Skeleton variant="text" width="66%" height={26} />
                <Skeleton variant="text" width="70%" height={26} />
                <Skeleton variant="rounded" width={100} height={28} />
              </Box>
            ))}
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Skeleton variant="rounded" height={388} sx={{ borderRadius: "18px" }} />
            <Skeleton variant="rounded" height={138} sx={{ borderRadius: "18px" }} />
            <Skeleton variant="rounded" height={220} sx={{ borderRadius: "18px" }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const PlayGameRouteSkeleton = () => {
  return (
    <Box sx={{ width: "100%", minHeight: "100vh", backgroundColor: "#fafafa" }}>
      <Box
        sx={{
          height: 86,
          borderBottom: "1px solid #e6e8ec",
          background: "#ffffff",
          display: "grid",
          gridTemplateColumns: "180px 1fr 180px",
          alignItems: "center",
          gap: 2,
          px: { xs: 2, md: 4 },
        }}
      >
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <Skeleton variant="rounded" width={78} height={34} sx={{ borderRadius: "999px" }} />
          <Skeleton variant="rounded" width={92} height={34} sx={{ borderRadius: "999px" }} />
        </Box>
        <Skeleton variant="text" width={230} height={28} sx={{ mx: "auto" }} />
        <Skeleton
          variant="rounded"
          width={112}
          height={34}
          sx={{ borderRadius: "999px", justifySelf: "end" }}
        />
      </Box>

      <Box
        sx={{
          minHeight: "calc(100vh - 86px)",
          display: "grid",
          placeItems: "center",
          px: 2,
          py: 5,
        }}
      >
        <Box
          sx={{
            width: "min(936px, 100%)",
            borderRadius: "26px",
            background: "#ffffff",
            p: { xs: 3, md: 5 },
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5 }}>
            <Skeleton variant="rounded" width={116} height={34} sx={{ borderRadius: "999px" }} />
            <Box sx={{ display: "flex", gap: 1 }}>
              <Skeleton variant="circular" width={34} height={34} />
              <Skeleton variant="circular" width={34} height={34} />
            </Box>
          </Box>

          <Skeleton variant="text" width="74%" height={42} />
          <Skeleton variant="text" width={190} height={24} sx={{ mb: 4 }} />

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: 2,
            }}
          >
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton
                key={`play-game-option-skeleton-${index}`}
                variant="rounded"
                height={58}
                sx={{ borderRadius: "16px" }}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const ViewListRouteSkeleton = () => {
  const renderKeywordCard = (idx) => (
    <Grid item xs={12} sm={6} md={4} key={`route-view-list-keyword-${idx}`}>
      <Box
        sx={{
          borderRadius: "18px",
          border: "1px solid rgba(15, 23, 42, 0.08)",
          backgroundColor: "#ffffff",
          p: 1.5,
        }}
      >
        <Skeleton variant="rounded" height={178} sx={{ borderRadius: "14px", mb: 1.5 }} />
        <Skeleton variant="text" width="52%" height={28} />
        <Skeleton variant="text" width="94%" height={18} />
        <Skeleton variant="text" width="76%" height={18} />
        <Box sx={{ mt: 1.6, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ display: "flex", gap: 0.7 }}>
            <Skeleton variant="circular" width={28} height={28} />
            <Skeleton variant="circular" width={28} height={28} />
          </Box>
          <Skeleton variant="circular" width={28} height={28} />
        </Box>
      </Box>
    </Grid>
  );

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", backgroundColor: "#ffffff", pb: "56px" }}>
      <Box
        sx={{
          width: "min(1660px, 100%)",
          mx: "auto",
          px: "clamp(16px, 4vw, 48px)",
          pt: "42px",
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "minmax(0, 1fr) 320px" },
          gap: 3,
          alignItems: "start",
        }}
      >
        <Box>
          <Box sx={{ display: "grid", gap: 1.5, justifyItems: "center", mb: 3 }}>
            <Skeleton variant="rounded" width={48} height={48} sx={{ borderRadius: "999px", justifySelf: "start" }} />
            <Skeleton variant="text" width={88} height={24} />
            <Skeleton variant="text" width="min(34vw, 300px)" height={54} />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
              <Skeleton variant="circular" width={34} height={34} />
              <Box>
                <Skeleton variant="text" width={130} height={24} />
                <Skeleton variant="text" width={48} height={18} />
              </Box>
            </Box>
            <Box sx={{ display: "flex", gap: 1.2, flexWrap: "wrap", justifyContent: "center" }}>
              <Skeleton variant="rounded" width={190} height={46} sx={{ borderRadius: "999px" }} />
              <Skeleton variant="rounded" width={128} height={46} sx={{ borderRadius: "999px" }} />
              <Skeleton variant="rounded" width={146} height={46} sx={{ borderRadius: "999px" }} />
              <Skeleton variant="rounded" width={184} height={46} sx={{ borderRadius: "999px" }} />
            </Box>
          </Box>

          <Grid container spacing={2}>
            {Array.from({ length: 6 }).map((_, idx) => renderKeywordCard(idx))}
          </Grid>
        </Box>

        <Box
          sx={{
            borderRadius: "22px",
            border: "1px solid rgba(15, 23, 42, 0.08)",
            backgroundColor: "#ffffff",
            p: 2,
            display: { xs: "none", lg: "block" },
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <Skeleton variant="circular" width={18} height={18} />
              <Skeleton variant="text" width={82} height={28} />
            </Box>
            <Skeleton variant="circular" width={28} height={28} />
          </Box>
          <Skeleton variant="rounded" width="100%" height={154} sx={{ borderRadius: "16px", mb: 2 }} />
          <Skeleton variant="rounded" width="100%" height={42} sx={{ borderRadius: "999px", mb: 1 }} />
          <Skeleton variant="rounded" width="100%" height={42} sx={{ borderRadius: "999px", mb: 1 }} />
          <Skeleton variant="rounded" width="100%" height={42} sx={{ borderRadius: "999px" }} />
        </Box>
      </Box>
    </Box>
  );
};

const EditProfileUserDetailsRouteSkeleton = ({ profileRoute = false }) => {
  return <EditUserDetailsSkeleton profileRoute={profileRoute} />;
};

const ChallengeHubRouteSkeleton = () => (
  <Box
    aria-label="Loading challenges"
    aria-busy="true"
    sx={{
      width: "min(1660px, 100%)",
      minHeight: "100vh",
      mx: "auto",
      px: "clamp(16px, 4vw, 48px)",
      pt: { xs: "20px", md: "52px" },
      pb: "64px",
      boxSizing: "border-box",
    }}
  >
    <Skeleton variant="text" width="min(420px, 80%)" height={48} sx={{ mb: 2 }} />
    <Box sx={{ display: "flex", gap: 2, overflow: "hidden", mb: 3 }}>
      {Array.from({ length: 3 }, (_, index) => (
        <Box
          key={index}
          sx={{
            flex: { xs: "0 0 86vw", md: "0 0 calc((100% - 32px) / 3)" },
            minHeight: { xs: 380, md: 430 },
            borderRadius: "20px",
            bgcolor: "#fff",
            p: 1.5,
            boxSizing: "border-box",
          }}
        >
          <Skeleton variant="rounded" sx={{ height: { xs: 250, md: 300 } }} />
          <Skeleton variant="text" width="38%" height={24} sx={{ mt: 1 }} />
          <Skeleton variant="text" width="75%" height={30} />
        </Box>
      ))}
    </Box>
    <Skeleton variant="rounded" width="min(344px, 100%)" height={52} sx={{ borderRadius: "999px", mb: 3 }} />
    <Skeleton variant="rounded" height={500} sx={{ borderRadius: "18px" }} />
  </Box>
);

const LoadingFallback = () => {
  const { pathname = "" } = useLocation();

  if (pathname.startsWith("/view-list/")) {
    return <ViewListRouteSkeleton />;
  }

  if (pathname === "/lists" || pathname.startsWith("/lists/")) {
    return <DashboardListsPageSkeleton />;
  }

  if (pathname === "/my-network" || pathname.startsWith("/my-network/")) {
    return <MyNetworkRouteSkeleton />;
  }

  if (
    pathname === "/profile" ||
    pathname.startsWith("/profile/")
  ) {
    return <EditProfileUserDetailsRouteSkeleton profileRoute />;
  }

  if (
    pathname === "/user-details" ||
    pathname.startsWith("/user-details/") ||
    pathname === "/edit-profile/user-details" ||
    pathname.startsWith("/edit-profile/user-details/")
  ) {
    return <EditProfileUserDetailsRouteSkeleton />;
  }

  if (pathname === "/playground" || pathname.startsWith("/playground/")) {
    return <PlaygroundRouteSkeleton />;
  }

  if (pathname === "/subscriptions" || pathname.startsWith("/subscriptions/")) {
    return <SubscriptionPageSkeleton />;
  }

  if (pathname === "/games/results" || pathname.startsWith("/games/results/")) {
    return <GamesResultsRouteSkeleton />;
  }

  if (
    pathname === "/games/match-game" ||
    pathname === "/games/multiple-choice" ||
    pathname === "/games/scrambled-keywords"
  ) {
    return <PlayGameRouteSkeleton />;
  }

  if (pathname === "/games" || pathname === "/games/") {
    return <GamesRouteSkeleton />;
  }

  if (pathname === "/challenge-hub" || pathname === "/challenge-hub/") {
    return <ChallengeHubRouteSkeleton />;
  }

  return <FullScreenSpinner />;
};

export default LoadingFallback;
